import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'

import { Grid } from "@material-ui/core";
import MenuItem from 'material-ui/MenuItem'
import Snackbar from 'material-ui/Snackbar'
import SelectField from 'material-ui/SelectField'
import Paper from 'material-ui/Paper'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import DatePicker from 'material-ui/DatePicker'

import mixpanel from '../../utils/mixpanel'

import { getThreadByNumbers, getThreadByNumbersWithDates } from '../../reducers/thread/resources'

import './index.css'

const REQUIRED_MSG = 'Required';
const INVALID_NUM_MSG = 'Invalid phone number';
const INVALID_TIME_MSG = 'Start Date must be earlier than End Date.'

class MessageAudit extends Component {
    componentWillMount = () => {
        this.setState({
            showSnackBar: false,
            snackbarMsg: '',
            threads: [],
            filters: {
                from: { value: '', error: '' },
                to: { value: '', error: '' },
                customStartDate: { value: '', error: '' },
                customEndDate: { value: '', error: '' },
                timerange: { value: '', error: '' },
            }
        })
    }

    resetFields = () => {
        return this.setState({
            filters: {
                timerange: { value: '', error: '' },
                from: { value: '', error: '' },
                to: { value: '' },
                customStartDate: { value: undefined, error: '' },
                customEndDate: { value: undefined, error: '' },
            },
            threads: []
        })
    }

    handleTextFilterChange = field => {
		return ( event, value ) => {
			let state = this.state;

            state['filters'][field].error = '';
			state['filters'][field].value = value;
			this.setState(state);
		}
	}

    handleSelectFilterChange = field => {
        return (event, index, value) => {
            let state = this.state;

            state['filters'][field].error = '';
			state['filters'][field].value = value;
			this.setState(state);
        }
    }

    validateNumber = (val) => {
        const trimmed = val.trim();
        return /^\+?[1-9]\d*$/.test(trimmed)
    }

    validateFields = () => {
        let hasError = false;
        let state = this.state;
        const {
            filters: {
                from,
                to,
                timerange,
                customStartDate,
                customEndDate
            }
        } = state;

        if(!from.value) {
            hasError = true
            state.filters.from.error = REQUIRED_MSG
        }

        if(!to.value) {
            hasError = true
            state.filters.to.error = REQUIRED_MSG
        }

        // if(from.value && !this.validateNumber(from.value)) {
        //     hasError = true
        //     state.filters.from.error = INVALID_NUM_MSG
        // }

        // if(to.value && !this.validateNumber(to.value)) {
        //     hasError = true
        //     state.filters.to.error = INVALID_NUM_MSG
        // }

        if(timerange.value === 'custom') {
            if(!customStartDate.value) {
                hasError = true
                state.filters.customStartDate.error = REQUIRED_MSG
            }
            
            if(!customEndDate.value) {
                hasError = true
                state.filters.customEndDate.error = REQUIRED_MSG
            }

            if(moment(customEndDate.value).diff(moment(customStartDate.value)) < 0) {
                hasError = true
                state.filters.customStartDate.error = INVALID_TIME_MSG
                state.filters.customEndDate.error = INVALID_TIME_MSG
            }
        }

        if(hasError) {
            state.showSnackBar = true;
            state.snackbarMsg = 'Some field(s) need your attention'
        }

        return hasError
    }

    convertToISO = date => {
        return date.toISOString();
    }

    onClickSearch = () => {
        const { filters } = this.state;
        const {
            from,
            to,
            timerange,
            customStartDate,
            customEndDate
        } = filters

        if(this.validateFields()) {
            this.setState({ showSnackBar: true })
            return;
        }

        this.setState({ showSnackBar: false, snackbarMsg: '' })

        mixpanel.track('message audit:search', { filters })
        
        if(!timerange.value) {
            getThreadByNumbers(from.value, to.value)
                .then(res => {
                    this.setState({ threads: res.data })
                })
        } else {
            let start = moment()
            let end = moment()

            if(timerange.value === 'lasthour') {
                start = moment().subtract(1, 'hour')
            } else if(timerange.value === 'yesterday') {
                start = moment().subtract(1, 'day').startOf('day')
                end = moment().subtract(1, 'day').endOf('day')
            } else if(timerange.value === 'last7days') {
                start = moment().subtract(7, 'days').startOf('day')
            } else if(timerange.value === 'last30days') {
                start = moment().subtract(30, 'days').startOf('day')
            } else if(timerange.value === 'custom') {
                start = moment(customStartDate.value).startOf('day')
                end = moment(customEndDate.value)
            } else {
                start = moment().startOf('day')
            }

            getThreadByNumbersWithDates(from.value, to.value, start.toISOString(), end.toISOString())
                .then(res => {
                    this.setState({ threads: res.data })
                })
        }
    }

    handleDisableFutureDays = (date) => {
        return Date.now() < Date.parse(date)
    }

    render() {
        let styles = {
            gridFluid: {
                height: '100%',
                backgroundColor: '#FBFBFB',
                overflowY: 'auto',
                paddingBottom: '150px',
            },
            searchFilter: {
                padding: '0 15px 10px',
                marginBottom: '5px',
            },
            searchFilterContainer: {
                marginBottom: '20px'
            },
            raisedButton: {
                marginRight: '15px',
            },
            column: {
                overflow: 'unset',
                whiteSpace: 'unset',
                textOverflow: 'unset',
                padding: '10px 24px'
            }
        }

        const { filters } = this.state

        const threads = this.state.threads.map((thread, idx) => {
            return (
                <TableRow key={idx}>
                    <TableRowColumn style={styles.column}>{thread.conversation_id}</TableRowColumn>
                    <TableRowColumn style={styles.column}>{thread.from}</TableRowColumn>
                    <TableRowColumn style={styles.column}>{thread.to}</TableRowColumn>
                    <TableRowColumn style={styles.column}>{thread.direction}</TableRowColumn>
                    <TableRowColumn style={styles.column}>{thread.message}</TableRowColumn>
                    <TableRowColumn style={styles.column}>{thread.message_status}</TableRowColumn>
                    <TableRowColumn style={styles.column}>{moment(thread.sent_to_vonage_on).format('MMMM D, YYYY - hh:mm:ss.SSS A')}</TableRowColumn>
                    <TableRowColumn style={styles.column}>{moment(thread.dlr_recieved_on).format('MMMM D, YYYY - hh:mm:ss.SSS A')}</TableRowColumn>
                </TableRow>
            )
        })

        return (
            <Grid fluid style={styles.gridFluid}>
                <Snackbar
                    open={this.state.showSnackBar}
                    message={this.state.snackbarMsg}
                    autoHideDuration={4000}
                    onRequestClose={() => this.setState({ showSnackBar: false })}
                />
                <div>
                    <div style={{ height: '80px', backgroundColor: '#F5F5F5'}}>
                        <div style={{ height: '100%', width: '90%', padding: '20px', margin: '0 auto'}}>
                            <h2 style={{ margin: 0 }}>Message Audit</h2>
                        </div>
                    </div>
                    <div className="message-audit-content">
                        <div>
                            <Row className="audit-container">
                                <Col xs={12} style={styles.searchFilterContainer} className="audit-filters">
                                    <Paper style={styles.searchFilter}>
                                        <Row>
                                            <Col lg={3} xs={12}>
                                                <TextField
                                                    fullWidth={true}
                                                    floatingLabelText="From"
                                                    floatingLabelFixed={true}
                                                    value={filters.from.value}
                                                    errorText={filters.from.error}
                                                    onChange={this.handleTextFilterChange('from')}
                                                />
                                            </Col>
                                            <Col lg={3} xs={12}>
                                                <TextField
                                                    fullWidth={true}
                                                    floatingLabelText="To"
                                                    floatingLabelFixed={true}
                                                    value={filters.to.value}
                                                    errorText={filters.to.error}
                                                    onChange={this.handleTextFilterChange('to')}
                                                />
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: '20px' }}>
                                            <Col lg={3} xs={12}>
                                                <SelectField
                                                    fullWidth={true}
                                                    floatingLabelText="Time Range"
                                                    floatingLabelFixed={true}
                                                    value={filters.timerange.value}
                                                    errorText={filters.timerange.error}
                                                    onChange={this.handleSelectFilterChange('timerange')}
                                                >
                                                    <MenuItem value="" primaryText="All" />
                                                    <MenuItem value="lasthour" primaryText="Last Hour" />
                                                    <MenuItem value="today" primaryText="Today" />
                                                    <MenuItem value="yesterday" primaryText="Yesterday" />
                                                    <MenuItem value="last7days" primaryText="Last 7 Days" />
                                                    <MenuItem value="last30days" primaryText="Last 30 Days" />
                                                    <MenuItem value="custom" primaryText="Custom" />
                                                </SelectField>
                                            </Col>
                                            {filters.timerange.value === 'custom' ? <Col lg={6} xs={12}>
                                                <Col
                                                    lg={9} xs={12}
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    <DatePicker
                                                        fullWidth={true}
                                                        floatingLabelText="Start Date"
                                                        floatingLabelFixed={true}
                                                        onChange={this.handleTextFilterChange('customStartDate')}
                                                        value={filters.customStartDate.value}
                                                        errorText={filters.customStartDate.error}
                                                        shouldDisableDate={this.handleDisableFutureDays}
                                                    />
                                                    -
                                                    <DatePicker
                                                        fullWidth={true}
                                                        floatingLabelText="End Date"
                                                        floatingLabelFixed={true}
                                                        onChange={this.handleTextFilterChange('customEndDate')}
                                                        value={filters.customEndDate.value}
                                                        errorText={filters.customEndDate.error}
                                                        shouldDisableDate={this.handleDisableFutureDays}
                                                    />
                                                </Col>
                                            </Col> : ''}
                                        </Row>
                                        <Row style={{ marginTop: '20px' }}>
                                            <Col lg={4} xs={12}>
                                                <RaisedButton style={styles.raisedButton} label="Search" onClick={this.onClickSearch} primary={true}/>
                                                <RaisedButton label="Clear Selection" onClick={this.resetFields} primary={false}/>
                                            </Col>
                                        </Row>
                                    </Paper>
                                </Col>
                                {/* <Col
                                    style={{ height: '100%', overflow: 'auto', marginBottom: '150px' }}
                                > */}
                                    <Col xs={12} className="thread-list">
                                        <Table fixedHeader={true} height='75vh' className="threads-table">
                                            <TableHeader
                                                displaySelectAll={false}
                                                adjustForCheckbox={false}
                                                className="thread-table-headers"
                                            >
                                                <TableRow>
                                                    <TableHeaderColumn>
                                                        Conversation ID
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn>
                                                        From
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn>
                                                        To
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn>
                                                        Direction
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn>
                                                        Message Body
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn>
                                                        Status
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn>
                                                        Sent to Vonage Date
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn>
                                                        DLR Received Date
                                                    </TableHeaderColumn>
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody displayRowCheckbox={false}>
                                                {threads.length ? threads : (
                                                    <div
                                                        style={{
                                                            marginTop: '20px',
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        No results found.
                                                    </div>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </Col>
                                {/* </Col> */}
                            </Row>
                        </div>
                    </div>
                </div>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => {
  const {
    company: { selectedCompany },
  } = state
  return { selectedCompany }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageAudit)